import { cloneDeep } from 'lodash-es'
import { v4 as uuidv4 } from 'uuid'
import { SpreadsheetMapping } from 'api'

export function cloneMapping<M extends SpreadsheetMapping>(mapping: M, currentUserId: string): M {
  const result = cloneDeep(mapping)
  result.name = `${mapping.name} (Copy)`
  result.userId = currentUserId
  result.id = uuidv4()
  result.lastSetAsDefault = null
  return result
}

export function getAllHeadings(rows: any[]) {
  return rows.length === 0 ? [] : Object.keys(rows[0]).filter(heading => !heading.startsWith('__EMPTY'))
}

export const removeIdsFromMapping = (spreadsheetMapping: SpreadsheetMapping) => ({ ...spreadsheetMapping, userId: '', id: '' })
